import { FC } from 'react';
import { ReactComponent as Member } from '../../assets/icon/member.svg';
import { ReactComponent as Search } from '../../assets/icon/search.svg';
import { ReactComponent as Logo } from '../../assets/logo/andCOCO_logo.svg';
import { Link } from '../Link.client';
import { CartIcon } from './CartIcon.client';
import { MobileNavigation } from './MobileNavigation.client';

interface Props {
  isLogin: boolean;
  onClickSearch: () => void;
}

export const MobileHeader: FC<Props> = ({ isLogin, onClickSearch }) => (
  <>
    <div className="bg-brand py-1">
      <p className="text-center text-sm text-white">新規会員登録で10%OFF</p>
    </div>
    <div className="flex items-center justify-between px-4 py-1">
      <div className="w-24">
        <div>
          <button onClick={onClickSearch}>
            <Search />
          </button>
        </div>
        <div />
      </div>
      <div className=" flex flex-col items-center">
        <Link route="home">
          <Logo width={150} />
        </Link>
      </div>
      <div className="flex w-24 flex-row items-center justify-end gap-x-4">
        <div>
          <Link route="account">
            <Member />
          </Link>
        </div>
        <div>
          <Link route="cart">
            <CartIcon />
          </Link>
        </div>
      </div>
    </div>
    <MobileNavigation isLogin={isLogin} />
  </>
);
